import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Ajay Prajapati</h1>
    </div>
  );
}

export default App;
